import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Theme } from '@radix-ui/themes';
import { BrowserRouter } from 'react-router-dom';

import '@radix-ui/themes/styles.css';
import './styles/index.css';
import App from './App';
import { initSentry } from './config/sentry';
import { LibraryProvider } from './library-provider';

async function main() {
  const Sentry = await initSentry();

  if (import.meta.env.MODE === 'development' || import.meta.env.DEV) {
    try {
      const { IS_MOCKING_ENABLED } = await import('./mocks/setup');

      if (IS_MOCKING_ENABLED) {
        const { worker } = await import('./mocks/browser');
        await worker.start({
          onUnhandledRequest: 'bypass',
        });
      }
    } catch (error) {
      console.error('❌ Błąd inicjalizacji Mock Service Worker:', error);
    }
  }

  const renderApp = () => {
    const app = <App />;

    createRoot(document.getElementById('react-app')!).render(
      <StrictMode>
        <LibraryProvider>
          <BrowserRouter>
            <Theme className="bg-transparent">
              {Sentry ? (
                <Sentry.ErrorBoundary
                  fallback={
                    <div role="alert">
                      Wystąpił nieoczekiwany błąd aplikacji.
                    </div>
                  }
                >
                  {app}
                </Sentry.ErrorBoundary>
              ) : (
                app
              )}
            </Theme>
          </BrowserRouter>
        </LibraryProvider>
      </StrictMode>,
    );
  };

  renderApp();
}

main();
